// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ruGU_nOPecjgPtuAF8Ct {
  position: relative;
  text-align: center;
}
.EXcW1QGWYEbJp25cvzBQ {
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  cursor: pointer;
  border-color: none;
  font-size: 1.25rem;
  line-height: 1.75rem;
  background: transparent;
}
.R3P7DRonvNmwQfT8_viM {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}
.DD1uF9mJDg3mX8BYYsti {
  height: 60px;
  width: 60px;
  border-radius: 5px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1));
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
  outline: none;
}
.xBwRoEGeaSXQugYPVJwA {
  font-family: Noto Sans;
  font-size: 35px;
  font-weight: 700;
}
.pyd9mLZy8wKDtUs5jKZw {
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 1.25rem;
}
.YMn4OwlLSONfVyj3wUe_ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: Noto Sans !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(141 141 141 / var(--tw-text-opacity, 1));
}
.deZ46AK7e57JcSGewmB1 {
  margin: auto;
  display: flex;
  height: 38px;
  width: 420px !important;
  justify-content: center;
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.deZ46AK7e57JcSGewmB1:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.Y4s2PZgR2Bewp0i6CqHV {
  margin: auto;
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
  display: flex;
  text-decoration-line: underline;
  text-underline-offset: 4px;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 700;
  --tw-text-opacity: 1 !important;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important;
}

.zlcO7xicXv8TMekcawxJ {
  font-family: Noto Sans !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.poLLBIqwK2OF3mQZgf49 {
  cursor: not-allowed;
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/OTPModal/OtpModal.module.css"],"names":[],"mappings":"AACE;EAAA,kBAA2B;EAA3B;AAA2B;AAG3B;EAAA,kBAAkE;EAAlE,cAAkE;EAAlE,YAAkE;EAAlE,eAAkE;EAAlE,kBAAkE;EAAlE,kBAAkE;EAAlE,oBAAkE;EAClE;AADkE;AAIlE;EAAA,kBAAsC;EAAtC,qBAAsC;EAAtC,aAAsC;EAAtC,uBAAsC;EAAtC;AAAsC;AAGtC;EAAA,YAA6G;EAA7G,WAA6G;EAA7G,kBAA6G;EAA7G,iBAA6G;EAA7G,sBAA6G;EAA7G,4DAA6G;EAA7G,kBAA6G;EAA7G,eAA6G;EAA7G,mBAA6G;EAA7G,gBAA6G;EAA7G,oBAA6G;EAA7G,mDAA6G;EAC7G;AAD6G;AAI7G;EAAA,sBAAuC;EAAvC,eAAuC;EAAvC;AAAuC;AAGvC;EAAA,mBAA6D;EAA7D,aAA6D;EAA7D,sBAA6D;EAA7D,mBAA6D;EAA7D,uBAA6D;EAA7D;AAA6D;AAG7D;EAAA,aAA8F;EAA9F,sBAA8F;EAA9F,mBAA8F;EAA9F,uBAA8F;EAA9F,iCAA8F;EAA9F,mBAA8F;EAA9F,oBAA8F;EAA9F,gBAA8F;EAA9F,oBAA8F;EAA9F;AAA8F;AAG9F;EAAA,YAAkB;EAAlB,aAAkB;EAClB,YAA+D;EAA/D,uBAA+D;EAA/D,uBAA+D;EAA/D,kBAA+D;EAA/D,0DAA+D;EAA/D,oBAA+D;EAA/D;AADkB;AAIlB;EAAA,6BAA8B;EAA9B,qEAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;AAG9B;EAAA,YAAyD;EAAzD,mBAAyD;EAAzD,qBAAyD;EAAzD,aAAyD;EAAzD,+BAAyD;EAAzD,0BAAyD;EACzD,sBAAqD;EAArD,eAAqD;EAArD,gBAAqD;EAArD,+BAAqD;EAArD;AADyD;;AAKzD;EAAA,iCAA0B;EAA1B,mBAA0B;EAA1B;AAA0B;;AAG5B;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".otpModal {\n  @apply relative text-center;\n}\n.closeBtn {\n  @apply absolute text-xl cursor-pointer border-[none] right-3 top-3;\n  background: transparent;\n}\n.otpWrapper {\n  @apply flex justify-center gap-4 my-10;\n}\n.otpInput {\n  @apply w-[60px] h-[60px] text-center text-base font-normal text-gray-300 rounded-[5px] border border-gray-200;\n  outline: none;\n}\n.header {\n  @apply text-[35px] font-inter font-bold;\n}\n.modalContainer {\n  @apply flex flex-col justify-center items-center gap-y-5 mt-5;\n}\n.infoContainer {\n  @apply flex flex-col justify-center items-center text-gray-400 font-normal text-sm !font-inter;\n}\n.applyButton {\n  @apply flex m-auto;\n  @apply bg-primary text-white !w-[420px] h-[38px] justify-center;\n}\n.applyButton:hover {\n  @apply !bg-primary !text-white;\n}\n.resendButton {\n  @apply underline underline-offset-4 flex mt-3 mb-6 m-auto;\n  @apply !text-primary text-[12px] font-bold font-inter;\n}\n\n.otpNote {\n  @apply !font-inter text-sm;\n}\n\n.disabledResend {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otpModal": `ruGU_nOPecjgPtuAF8Ct`,
	"closeBtn": `EXcW1QGWYEbJp25cvzBQ`,
	"otpWrapper": `R3P7DRonvNmwQfT8_viM`,
	"otpInput": `DD1uF9mJDg3mX8BYYsti`,
	"header": `xBwRoEGeaSXQugYPVJwA`,
	"modalContainer": `pyd9mLZy8wKDtUs5jKZw`,
	"infoContainer": `YMn4OwlLSONfVyj3wUe_`,
	"applyButton": `deZ46AK7e57JcSGewmB1`,
	"resendButton": `Y4s2PZgR2Bewp0i6CqHV`,
	"otpNote": `zlcO7xicXv8TMekcawxJ`,
	"disabledResend": `poLLBIqwK2OF3mQZgf49`
};
export default ___CSS_LOADER_EXPORT___;
